<app-crm-segment-definitions-toolbar (addNew)="openAddPanel()" />

<app-crm-segment-definitions-list
  [reloadVersion]="reloadVersion"
  (edit)="openEditPanel($event)"
  (deleted)="onDeleted()" />

<app-crm-segment-definitions-form-panel
  [visible]="showFormPanel"
  [segmentId]="selectedSegmentId"
  (visibleChange)="onFormVisibilityChange($event)"
  (saved)="onSaved()" />
